import { render, staticRenderFns } from "./FlexibleProduct.vue?vue&type=template&id=2270689f&"
import script from "./FlexibleProduct.vue?vue&type=script&lang=js&"
export * from "./FlexibleProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FlexibleProduct.vue"
export default component.exports